module.exports = __webpack_public_path__ + "static/img/home_icon_help.03104c5d.png";